import {useMemo, useSyncExternalStore} from "react";

const useMedia = (query: string) => {
  const {matcher, sub} = useMemo(() => {
    const m = window.matchMedia(query.replace(/^@media\s+/, ""));
    return {
      matcher: m,
      sub: (cb: () => void) => {
        m.addEventListener("change", cb);
        return () => m.removeEventListener("change", cb);
      },
    };
  }, [query]);

  return useSyncExternalStore(sub, () => {
    try {
      return matcher.matches;
    } catch (e) {
      return false;
    }
  });
};

export default useMedia;
